module.exports = __webpack_public_path__ + "static/img/logo.ea074b8b.png";